import { resourceTypes, eventTypes, accessTypes } from "./options"

export const getOptionName = (options, selectedType) => {
  const selectedOption = options.find((option) => option.type === selectedType)
  return selectedOption?.title
}
export const getResourceTypeName = (type) => getOptionName(resourceTypes, type)
export const getEventTypeName = (type) => getOptionName(eventTypes, type)
export const getAccessTypeName = (type) => getOptionName(accessTypes, type)
